import { Box, Image, Text } from '@chakra-ui/react';
import { InfoEventBrief, Master, Paper } from 'components';
import React from 'react';
import { set } from 'lodash-es';
import { getImageUrl } from 'utils';
import {
  GroupEventInfo,
  MasterInfo,
  ServiceInfo,
  SpecialistCases,
} from '../types';

interface Props {
  widgetId?: string;
  event: GroupEventInfo;
  master?: MasterInfo;
  service?: ServiceInfo;
  specialistCases: SpecialistCases;
}

export const DetailsEvent: React.FC<Props> = ({
  widgetId,
  event,
  master,
  service,
  specialistCases,
}) => {
  if (!service) return null;
  const { id, description } = service;
  return (
    <Box w="100%">
      <Box>
        {widgetId && (
          <Image
            w="100%"
            maxH="306px"
            objectFit="cover"
            borderRadius="lg"
            src={getImageUrl(widgetId, 'Service', id)}
            loading="eager"
            alt=""
            onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
              set(e.target, ['style', 'display'], 'none');
            }}
          />
        )}
        <Box w="100%">
          <Paper my={4}>
            <InfoEventBrief event={event} showTime service={service} />
          </Paper>
          {master && master.isShow !== false && (
            <Master
              widgetId={widgetId}
              masterInfo={master}
              specialistCases={specialistCases}
            />
          )}
          {description && (
            <Paper mt={4}>
              <Text
                color="black"
                textStyle="body1"
                lineHeight="5"
                whiteSpace="pre-wrap"
              >
                {description}
              </Text>
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  );
};
